import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useCreateRegistration = () => {
  const queryClient = useQueryClient()
  const mutation = useApiMutation(
    'schools',
    ({ courseId }) => `courses/${courseId}/registrations`,
    'post',
    {
      onSuccess: () => {
        queryClient.removeQueries({ queryKey: ['enrollments-by-role-type'], type: 'inactive' })
        queryClient.removeQueries({ queryKey: ['registrations'], type: 'inactive' })
        queryClient.removeQueries({ queryKey: ['courses-by-term'], type: 'inactive' })
        queryClient.invalidateQueries({ queryKey: ['enrollments-by-role-type'] })
        queryClient.invalidateQueries({ queryKey: ['registrations'] })
        queryClient.invalidateQueries({ queryKey: ['courses-by-term'] })
      },
      onError: error => {
        console.error(error)
      }
    },
    { authenticated: true, version: 4 }
  )
  const { mutateAsync } = mutation

  const createRegistration = useCallback(async (enrollmentId, courseId, tags) => {
    return mutateAsync({
      courseId,
      data: {
        enrollmentId,
        tags: tags || []
      }
    })
      .catch(error => {
        console.error(error)
        return null
      })
  }, [mutateAsync])

  return {
    createRegistration,
    loadingRegistration: mutation.isPending
  }
}
